import React from "react";

// État vide d'une section : icône décorative, titre, aide et action facultative.
const EmptyState = ({ icon = "fa-inbox", title, hint = null, action = null }) => (
  <div className="empty-state">
    <i className={`fa ${icon}`} aria-hidden="true" />
    <span className="empty-state__title">{title}</span>
    {hint && <small className="empty-state__hint">{hint}</small>}
    {action && (
      <div className="empty-state__action">
        <button type="button" className="btn btn-ghost" onClick={action.onClick}>
          {action.label}
        </button>
      </div>
    )}
  </div>
);

export default EmptyState;
